// Import Core
import React from 'react'
// Import Components
import ResultCards from '../blocks/Cards/ResultCards';
// Import Logic
import { getHotelsOrPagesFromIds } from '../../utils/logic/getHotelsOrPagesFromIds';
import { getHotelRanks } from '../../utils/logic/getHotelRanks';
import { getHotelSpecialOffers } from '../../utils/logic/getHotelSpecialOffers';
import { getMainBlockHotels } from '../../utils/logic/getMainBlockHotels';
import { getHotelsBySearchTags } from '../../utils/logic/getHotelsBySearchTags';

// Render Additional Collection Page Type Sections
const RenderAdditionalCollectionBlocks = ({ pillar, allFilteredHotels, allHotels, specialOfferHotelResults, goldOffers, silverOffers, internationalOffers, mainBlockHotelResults, pillarSummaryTag, sectionTitle, placeholderImage }) => {

  // Depending on if additional collection content is manually added or automatic it will need to be rendered differently as manually may have more than one section
  const renderCollectionSections = (allFilteredHotels, section, index) => {
    const filteredHotelResults = getHotelsOrPagesFromIds(
      allHotels,
      allFilteredHotels
    );

    // Sort hotels into ranks
    let hotelResults = getHotelRanks(filteredHotelResults);

    // -> SPECIAL OFFERS
    // Then
    specialOfferHotelResults = getHotelSpecialOffers(
      hotelResults,
      goldOffers,
      silverOffers,
      internationalOffers
    );

    mainBlockHotelResults = getMainBlockHotels(
      hotelResults,
      specialOfferHotelResults
    );

    hotelResults = specialOfferHotelResults.concat(mainBlockHotelResults);

    if(section) {
      sectionTitle = {
        subtitle: section.subheading ? section.subheading : false,
        title: section.title,
        caption: section.caption ? section.caption : false
      }
      return (
        <section key={index}>
          {/* Return all results within each editor's choice section */}
          {(hotelResults.length > 0 && (
            <ResultCards
              key={section.title}
              hotels={hotelResults}
              pillarSummaryTag={pillarSummaryTag}
              sectionTitle={sectionTitle}
              className='result-cards-vertical'
              placeholderImage={placeholderImage}
            />
          )) ||
            null}
        </section>
      );
    } else {
      let pillarName = pillar.name;
			let featuredSectionTitle = `More ${pillarName}`;
      // If hotel has a number at the beginning e.g., '10 of the best', remove '10' then add 'more'
      for (let i = 0; i <= 100; i += 1) {
        if(pillarName.startsWith(i.toString())) featuredSectionTitle = `More ${pillarName.replace(i.toString(), '')}`;
      }
      sectionTitle = {
        title: pillar.pageTypeCollectionSection ? pillar.pageTypeCollectionSection.title : featuredSectionTitle,
      }

      {/* Return all results within each editor's choice section */}
      return hotelResults.length > 0 && (
        <ResultCards
          key={pillar.pageTypeCollectionSection.title}
          hotels={hotelResults}
          pillarSummaryTag={pillarSummaryTag}
          sectionTitle={sectionTitle}
          className='result-cards-vertical'
          placeholderImage={placeholderImage}
        />
      ) || null
    }
  }

  // Loop through and get hotel ids and change object to array with id value
  if(pillar.pageTypeCollectionSection.pageDisplay === 'auto') {
    allFilteredHotels = getHotelsBySearchTags(allHotels, pillar);

    return renderCollectionSections(allFilteredHotels)
  }
  else if(pillar.pageTypeCollectionSection.pageTypeCollectionSection) {
    let collectionPageAdditonalSections = pillar.pageTypeCollectionSection.pageTypeCollectionSection;
    return collectionPageAdditonalSections.map((section, index) => {
    
      allFilteredHotels = section.pageTypeCollectionSelectedHotels.map(
        (hotel) => hotel._id
      );

      return renderCollectionSections(allFilteredHotels, section, index)
      
    });
  } else {
    return null
  }
}

export default RenderAdditionalCollectionBlocks;